<template>
    <div class="loading-box" v-if="show">
      <a-card class="loading-card" :bordered="false" style="width: 300px">
        <a-spin :tip="text" size="large" />
      </a-card>
    </div>
</template>

<script>
export default {
  props: {
    text: {
      default: 'Executando...',
    },
    show: {
      default: false,
    },
  },
}
</script>

<style>
.loading-box{
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100000;
  background: rgba(255,255,255,1);
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center
}
.loading-card{
  display: flex;
  justify-content: center;
  align-items: center
}
</style>
